export const textLQOP1 = {
    fr: {
        desc: [
            "Situé à Charlemagne, en bordure de la rivière des Prairies et à proximité du parc de conservation du ruisseau de Feu, Quartier Oviv vous invite à découvrir un cadre de vie unique. Ce projet novateur de 1236 unités réparties en 7 phases, imaginé par l’entreprise immobilière SIMDEV, incarne une approche créative et visionnaire pour redéfinir l’essence de la vie en communauté.",
        ]
    },
    en: {
        desc: [
            "Situé à Charlemagne, en bordure de la rivière des Prairies et à proximité du parc de conservation du ruisseau de Feu, Quartier Oviv vous invite à découvrir un cadre de vie unique. Ce projet novateur de 1236 unités réparties en 7 phases, imaginé par l’entreprise immobilière SIMDEV, incarne une approche créative et visionnaire pour redéfinir l’essence de la vie en communauté.",
        ]
    }
}

